import { FC, PropsWithChildren, useCallback } from 'react';
import { faFilterList } from '@fortawesome/pro-regular-svg-icons';
import { selectOverlay } from 'ducks/overlays/selectors';
import { clearOverlay } from 'ducks/overlays/slices';
import { Button } from 'framework/button';
import { Icon } from 'framework/Icon';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { resetQueries } from 'utils/queries';

import { Overlay } from '../../overlay';
import { useFiltersContext } from '../context/FiltersContext';

import cn from './Strategies.module.scss';

export const StrategiesOverlay: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { is_open } = useAppSelector(selectOverlay('strategies'));

  const { queries, filters, onSubmit, updateFilters } = useFiltersContext();

  const onClose = useCallback(() => {
    updateFilters(queries);
    dispatch(clearOverlay('strategies'));
  }, [dispatch, queries, updateFilters]);

  const onReset = useCallback(() => {
    updateFilters(resetQueries(filters));
  }, [filters, updateFilters]);

  return (
    <Overlay is_open={is_open} onClose={onClose}>
      <Overlay.Header dismiss>
        <Icon icon={faFilterList} size="inherit" button />
        Strategy Filters
      </Overlay.Header>
      <Overlay.Body>{children}</Overlay.Body>
      <Overlay.Footer>
        <p className="link" onClick={onReset}>
          Reset
        </p>
        <div className={cn.flex} />
        <Button onClick={onSubmit}>Apply</Button>
      </Overlay.Footer>
    </Overlay>
  );
};
